module.exports = __webpack_public_path__ + "img/LogoLoading_circle01.1fdaca67.png";